<template lang="pug">
	div
		b-container.top-sponsor-container.d-sm-none.d-none.d-md-block.d-print-none(fluid :class="{'collapsed': collapseDiv}" v-if="showTopSponsor && !userSubscribed()" )
			no-ssr
				b-row.top-banner-container()
					b-col(md="12")
						div(id="top-banner")
							//div(v-if="studentLoan")
								b-row
									sfc-dfp-ad#top-banner-desktop(ad-unit="savingforcollege_studentloan_top_leaderboard" sizes="[728,90]"  delay="0" :class="{'empty' : !showingAdClass }")
							//div(v-else-if="showCollegeAd")
							div(v-if="showCollegeAd")
								b-row
									sfc-dfp-ad#top-banner-desktop(ad-unit="savingforcollege_COLLEGE_top_leaderboard" sizes="[728,90]" delay="0" :class="{'empty' : !showingAdClass }")
							div(v-else)
								b-row
									sfc-dfp-ad#top-banner-desktop(:ad-unit="topBannerAdUnit" sizes="[728,90]"  delay="0" :class="{'empty' : !showingAdClass }")

		b-container.top-sponsor-container-mobile.d-sm-block.d-md-none.d-print-none(:class="{'collapsed': collapseDiv}" v-if="showTopSponsor && !userSubscribed()" )
			no-ssr
				b-row.top-banner-container-mobile()
					sfc-dfp-ad#top-banner-mobile(ad-unit="savingforcollege_other_mobile_leaderboard" sizes="[[300,50], [320,50]]" delay="0" :mobile="true" :class="{'empty' : !showingAdClass }")
</template>

<style lang="stylus" scoped>
	@import '~assets/css/variables.styl'

	.top-sponsor-container
		min-height: 120px
		height: 120px
		background #ecf1f5
		&.collapsed
			min-height: 40px
			height: 40px

	.top-sponsor-container-mobile
		min-height: 70px
		height: 70px
		background #ecf1f5
		&.collapsed
			min-height: 20px
			height: 20px

	.top-sponsor-empty-container
		height: 40px

	.top-sponsor-container
	.top-sponsor-container-mobile
		margin: 0 auto
		width: 100%
		max-width: 100%
		#top-banner-desktop
			width: 100%
			margin: 0 auto
			text-align: center
			display: none
			&:not(.empty)
				height: 120px
				display: block
				padding: 15px
				background: bg-light-blue
				border-bottom: 1px solid sfc-pale-gray
		#top-banner-mobile
			width: 100%
			margin: 0 auto
			text-align: center
			display: none
			&:not(.empty)
				height: 70px
				display: block
				padding: 10px
				background: bg-light-blue
				border-bottom: 1px solid sfc-pale-gray
		@media screen and (max-width: 576px)
			margin-top: 0px !important
</style>

<script>

export default {
	props: {
		studentLoan: {
			type: Boolean,
			default: false
		}
	},
	data: function() {
		let showTopSponsor = this.$route.path != '/529-plans/portfolio-snapshots';
		let showCollegeAd = (this.$route.path.indexOf('/college/')>=0);
		let topBannerAdUnit = (this.$route.path.indexOf('/pro-dashboard')>=0) ? 'savingforcollege_prodashboard_top_leaderboard' : 'savingforcollege_other_top_leaderboard';
		return {
			showTopSponsor: showTopSponsor,
			showCollegeAd,
			topBannerAdUnit,
			showingAdClass: true,
			collapseDiv: false
		}
	},
	mounted() {
		this.checkForAdBanner()
		if(process.browser && this.userSubscribed()){
			this.collapseDiv = true
		}
	},
	methods: {
		checkForAdBanner(){
			if(process.browser){
				document.onreadystatechange = () => {

				if (document.readyState == "complete") {
							setTimeout( () => {
								// find desktop ad
								try{
									let showingAd = document.getElementById('top-banner-ad')
									// if not desktop find mobile ad
									if(showingAd == null){
										let showingAd = document.getElementById('top-banner-mobile')
									}
									// get aside element inside ad
									let showingAdAside = showingAd.getElementsByTagName("aside")[0]

									// if ad has content it will display
									if(showingAdAside.style.display == 'none'){
										this.showingAdClass = false
									}
									else{
										this.showingAdClass = true
									}
								}catch (e){

								}

							}, 500)
						}
				}
			}
		},
		userSubscribed(){
			return (this.$store.state.sfcSubscriptions && this.$store.state.sfcSubscriptions.subscription_order_id)
		}

	},

	components: {
	}
}
</script>



